import { PARTNERS } from "../../data/site";

// Uniform white wordmarks instead of mismatched baked PNG logos, so every
// partner reads consistently on the dark theme.
export default function Partners({ items = PARTNERS }) {
  return (
    <ul className="partners">
      {items.map((name) => (
        <li key={name} className="partners__item">
          {name}
        </li>
      ))}
    </ul>
  );
}
